import * as React from 'react';
import DateSingle from 'src/components/common/DateSingle';
import './ECheckFilterBar.scss';
import Select from 'src/components/common/Select';
import {
  IPaymentFilters,
  IPagination
} from 'src/services/paySimple/paySimpleService';
import SearchIcon from 'src/assets/searchIcon';
import CloseIcon from 'src/assets/close';
import * as moment from 'moment';
import env from 'src/shared/env';
interface IECheckFilterBarState {
  statusFilter: {
    value: 'AT' | 'DT' | null;
    label: string;
  };

  dispositionFilter: {
    value: 'AW' | 'AD' | 'VT' | null;
    label: string;
  };
  searchValue: string;
  open: boolean;
  isReset: boolean;
  dateRange: '';
  date: moment.Moment;
}

interface IECheckFilterBarProps {
  handleFilteredPayments: (
    status?: 'AT' | 'DT',
    disposition?: 'AW' | 'AD' | 'VT'
  ) => void;
  getPayments: (
    filters: IPaymentFilters,
    pagination: IPagination,
    sort?: any
  ) => void;
  sort: string;
  filter: any;
  pagination: any;
  pageNumber: any;
}

class ECheckFilterBar extends React.Component<
  IECheckFilterBarProps,
  IECheckFilterBarState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      statusFilter: {
        value: null,
        label: 'All Transactions'
      },
      dispositionFilter: {
        value: null,
        label: 'All Transactions'
      },
      searchValue: '',
      open: false,
      isReset: false,
      dateRange: '',
      date: null
    };
    this.handleDateFromChange = this.handleDateFromChange.bind(this);
  }

  private setStatusFilter = (option: {
    value: 'AT' | 'DT' | null;
    label: string;
  }) => {
    this.setState({ statusFilter: option, searchValue: '', date: null }, () => {
      this.props.handleFilteredPayments(
        this.state.statusFilter.value,
        this.state.dispositionFilter.value
      );
    });
  };

  private setDispositionFilter = (option: {
    value: 'AW' | 'AD' | 'VT' | null;
    label: string;
  }) => {
    this.setState(
      { dispositionFilter: option, searchValue: '', date: null },
      () => {
        this.props.handleFilteredPayments(
          this.state.statusFilter.value,
          this.state.dispositionFilter.value
        );
      }
    );
  };
  // search box //

  private handlesearchChange = (event: any) => {
    // debugger
    this.setState({
      searchValue: event.currentTarget.value
    });
  };
  private handlesearch = (event: any) => {
    // console.log('this.props', this.props.pagination.page);
    // console.log('this.props', this.props.pagination.pageNumber);
    // debugger
    const addedfield = {
      userId: this.state.searchValue
    };
    this.setState({
      date: null
    });
    localStorage.setItem('searchFielda', this.state.searchValue);
    // console.log(addedfield);
    const check = Object.assign(this.props.filter, addedfield);

    this.props.getPayments(check, this.props.pageNumber, this.props.sort);
  };

  private handleDateFromChange(dateFromValue: any) {
    const paymentDate = { paymentDate: dateFromValue.format('YYYY-MM-DD') };
    this.setState({
      date: dateFromValue,
      searchValue: ''
    });
    // console.log('paymentDate', paymentDate.paymentDate);
    localStorage.setItem('searchPaymentDate', paymentDate.paymentDate);
    const finalResult = Object.assign(this.props.filter, paymentDate);

    this.props.getPayments(
      this.props.filter,
      this.props.pageNumber,
      this.props.sort
    );
  }
  private clearfilters = (e: any) => {
    localStorage.removeItem('searchPaymentDate');
    localStorage.removeItem('searchFielda');
    this.setState({
      date: this.state.date ? null : this.state.date,
      searchValue: this.state.searchValue ? '' : this.state.searchValue
    });
    this.props.getPayments(
      this.props.filter,
      this.props.pageNumber,
      this.props.sort
    );
  };

  public render() {
    const status = [
      { value: 'AT', label: 'Approved Transactions' },
      { value: 'DT', label: 'Declined Transactions' },
      { value: null, label: 'All Transactions' }
    ];

    const disposition = [
      { value: 'AW', label: 'Waiting for Dispose' },
      { value: 'AD', label: 'Already Dispositioned' },
      { value: 'VT', label: 'Voided Transactions' },
      { value: null, label: 'All Transactions' }
    ];

    return (
      <>
        <div className="rp-echeck-filterbar row">
          <div className="col-12 col-lg-4 rp-echeck-filterbar-title">
            <h4>List of E-Check Payments:</h4>
          </div>
        </div>
        <div className="rp-echeck-filterbar row">
          {/* <div className="col-12 col-lg-4 rp-echeck-filterbar-title">
          <h4>List of E-Check Payments:</h4>
        </div> */}
          <div className="col-12 col-lg-12 rp-echeck-filterbar-box d-flex flex-column flex-lg-row align-items-end justify-content-between">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
              <>
                <div className="rp-echeck-filterbar-transaction-type-filter date-picker-echeck pos-rel">
                  <DateSingle
                    onDateSelected={this.handleDateFromChange}
                    date={this.state.date}
                  />
                  {this.state.date && (
                    <img
                      className="close-icon"
                      alt="clear"
                      src={CloseIcon}
                      onClick={this.clearfilters}
                      style={{
                        position: 'absolute',
                        top: '15px',
                        right: '44px',
                        marginTop: '0',
                        cursor: 'pointer'
                      }}
                    />
                  )}
                </div>

                <div className="rp-echeck-filterbar-transaction-type-filter">
                  <div className="search-container d-flex ">
                    <input
                      type="text"
                      style={{
                        height: '40px',
                        width: '95%'
                      }}
                      placeholder="Search"
                      onChange={this.handlesearchChange}
                      value={this.state.searchValue}
                    />
                    {this.state.searchValue && (
                      <img
                        className="close-icon"
                        alt="clear"
                        src={CloseIcon}
                        onClick={this.clearfilters}
                        style={{
                          position: 'absolute',
                          top: '10px',
                          right: '53px',
                          marginTop: '0',
                          cursor: 'pointer'
                        }}
                      />
                    )}
                    <img
                      className="search-icon"
                      alt="search"
                      src={SearchIcon}
                      style={{
                        position: 'absolute',
                        right: '20px',
                        cursor: 'pointer',
                        top: '5px'
                      }}
                      onClick={this.handlesearch}
                    />
                  </div>
                </div>
              </>
            ) : (
              ''
            )}

            <div className="rp-echeck-filterbar-transaction-type-filter">
              <h5 className="rp-echeck-filterbar-top">Filter by:</h5>
              <Select
                options={status}
                optionsShown={3}
                activeOption={this.state.statusFilter}
                onSelected={option => {
                  this.setStatusFilter(option);
                }}
                width={'100%'}
                height={'40px'}
                isLoading={false}
                placeholder={'Status'}
              />
            </div>
            <div className="rp-echeck-filterbar-transaction-type-filter --rp-margin-left">
              <Select
                options={disposition}
                optionsShown={4}
                activeOption={this.state.dispositionFilter}
                onSelected={option => {
                  this.setDispositionFilter(option);
                }}
                width={'100%'}
                height={'40px'}
                isLoading={false}
                placeholder={'Disposition'}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ECheckFilterBar;
